"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthSigninState = exports["default"] = void 0;
var _eventNames = require("avo/eventNames");
var _react = _interopRequireWildcard(require("react"));
var _events = require("./events");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
;
var AuthSigninContext = /*#__PURE__*/_react["default"].createContext({});
var AuthSigninProvider = function AuthSigninProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showQRPopup = _useState2[0],
    setShowQRPopup = _useState2[1];
  var sendEvent = function sendEvent(clickedOn) {
    (0, _events.sendEventUsingAvo)({
      eventName: _eventNames.AVO_EVENT_NAMES.interactedLoginScreen,
      props: {
        clickedOn: clickedOn
      }
    });
  };
  var getFromPage = function getFromPage() {
    if (window.location.hash.includes('?')) {
      var queryString = window.location.hash.split('?')[1];
      var urlParams = new URLSearchParams(queryString);
      var fromPage = urlParams.get('fromPage');
      if (fromPage) {
        return decodeURIComponent(fromPage);
      }
    }
    return null;
  };
  var AuthSigninState = {
    sendEvent: sendEvent,
    showQRPopup: showQRPopup,
    setShowQRPopup: setShowQRPopup,
    getFromPage: getFromPage
  };
  return /*#__PURE__*/_react["default"].createElement(AuthSigninContext.Provider, {
    value: AuthSigninState,
    "data-sentry-element": "unknown",
    "data-sentry-component": "AuthSigninProvider",
    "data-sentry-source-file": "state.tsx"
  }, children);
};
var _useAuthSigninState = exports.useAuthSigninState = function useAuthSigninState() {
  var context = (0, _react.useContext)(AuthSigninContext);
  if (!context) {
    throw Error("Use ".concat(_useAuthSigninState.name, " in ").concat(AuthSigninContext.displayName));
  }
  return context;
};
var _default = exports["default"] = AuthSigninProvider;